import type { DebtAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateOwnership } from "../genericCalculations/ownership";

export const calculateDebtBalance = (userProduct: DebtAsset) => {
  const routes = userProduct?.routesData || [];

  return routes.reduce((sum, current) => {
    const amount = current?.remainder || 0;

    return sum + Number(amount);
  }, 0);
};

export const debtBalance = (
  userProduct: DebtAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const ownership = userProduct?.ownership || 0;
  const balance = calculateDebtBalance(userProduct);
  const convertedBalance = convertCurrency(
    balance,
    baseCurrency,
    currentCurrency
  );

  return calculateOwnership(convertedBalance, ownership);
};
